module.exports = __webpack_public_path__ + "static/img/norank-bg.5a9954dc.png";